import { defineStore } from "pinia";
import { ref, onMounted } from "vue";
import { useBase } from "@/utils/stores/base";

const storeName = "profession";

export const useProfessionStore = defineStore(storeName, () => {
  const all = ref([]);

  const { baseFetchAll, watchRemoteResourceChange } = useBase(storeName);

  const fetchAll = async (errorCallback) => {
    all.value = await baseFetchAll("professions", errorCallback);
  };

  onMounted(async () => {
    await fetchAll();
    await watchRemoteResourceChange(storeName, () => {
      fetchAll();
    });
  });

  return {
    professions: all,
    fetchProfessions: fetchAll
  };
});
